export const colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',

  danger: '#DE350B',
  dangerLight: '#FFBDAD',

  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)',
};

export const selectStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: 'white',
    borderColor: '#adb5bd',
    color: '#494949',
  }),
  dropdownIndicator: (styles) => ({
    ...styles,
    color: '#797979',
    '&:hover': {
      color: '#494949',
    },
  }),
  option: (styles) => ({
    ...styles,
    padding: '2px',
    paddingBottom: '0px',
    paddingLeft: '12px',
    ':hover': {
      backgroundColor: colors.primary25,
      color: colors.neutral90,
    },
    ':active': {
      backgroundColor: colors.primary,
      color: colors.neutral90,
    },
  }),
  groupHeading: (styles) => ({
    ...styles,
    padding: '2px',
    color: '#1A5A96',
    fontWeight: 'bold',
    fontSize: '75%',
    paddingLeft: '8px !important',
    selectedStyle: {
      //backgroundColor: colors.danger,
      //color: colors.neutral0,
    },
  }),
  container: (styles) => ({
    ...styles,
    borderColor: 'lightgrey',
    borderStyle: 'solid',
    borderRadius: '5px',
    borderWidth: 'thin',
  }),
  dropdownButton: (styles) => ({
    ...styles,
    width: '100%',
    borderRadius: '0.25rem',
    borderWidth: '1px',
  }),
};
